import React from "react";
import { motion } from "framer-motion";
import {
  PencilRuler, MessagesSquare, Users, Image as ImageIcon, ClipboardCheck, Timer,
} from "lucide-react";

const ITEMS = [
  {
    icon: <PencilRuler size={22} />,
    title: "Creezi fișe și teste în câteva minute",
    body: "Generezi rapid fișe de lucru, exerciții și teste adaptate temei și nivelului clasei tale.",
  },
  {
    icon: <MessagesSquare size={22} />,
    title: "Generezi feedback personalizat pentru elevi",
    body: "Construiești observații constructive și încurajatoare pentru fiecare elev, fără să petreci ore întregi cu evaluarea.",
  },
  {
    icon: <Users size={22} />,
    title: "Adaptezi lecțiile pentru niveluri diferite",
    body: "Pregătești variante simplificate, standard și avansate pentru elevi cu ritmuri și nevoi diferite de învățare.",
  },
  {
    icon: <ImageIcon size={22} />,
    title: "Pregătești mai rapid materiale pentru clasă",
    body: "Creezi prezentări, scheme, imagini și planșe atractive — fără experiență de design și fără software complicat.",
  },
  {
    icon: <ClipboardCheck size={22} />,
    title: "Primești exemple aplicabile la clasă",
    body: "Lucrezi pe exemple și scenarii practice adaptate activității didactice și situațiilor reale din clasă.",
  },
  {
    icon: <Timer size={22} />,
    title: "Reduci timpul cu sarcini administrative",
    body: "Simplifici documentele repetitive, rapoartele și comunicările care consumă timp săptămână de săptămână.",
  },
];

export default function Benefits() {
  return (
    <section id="benefits" className="py-20 md:py-28 bg-[#EDEEF0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl lg:max-w-4xl xl:max-w-5xl">
          <span className="inline-flex items-center rounded-full bg-[#F0E7F4] px-3 py-1 text-xs font-semibold text-[#965EA7] uppercase tracking-widest">
            Ce vei putea face în practică
          </span>
          <h2 className="mt-4 font-display text-3xl md:text-5xl font-bold text-[#373A45] !leading-[1.15] tracking-[-0.01em] lg:text-[2.75rem] xl:text-[3.25rem]">
            Folosește AI-ul ca să economisești timp și să predai mai eficient.
          </h2>
          <p className="mt-4 text-lg text-[#6B7280]">
            Instrumente și metode practice pe care le poți aplica imediat la clasă,
            indiferent de disciplina predată.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {ITEMS.map((it, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.45, delay: idx * 0.05 }}
              className="group bg-white rounded-2xl p-7 border border-[#E5E7EB] hover:border-[#965EA7]/50 hover:shadow-lg transition-all"
              data-testid={`benefit-card-${idx}`}
            >
              <div className="h-12 w-12 rounded-xl bg-[#3F8EBA] text-white grid place-items-center group-hover:bg-[#965EA7] transition-colors">
                {it.icon}
              </div>
              <h3 className="mt-5 font-display text-xl font-semibold text-[#373A45]">{it.title}</h3>
              <p className="mt-2 text-[#6B7280] leading-relaxed text-sm">{it.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
